import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '@modules/main/main.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { LoginComponent } from '@modules/login/login.component';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { PedidosTodosComponent } from '@pages/pedidos/pedidos-todos/pedidos-todos.component';
import { PedidosHoyComponent } from '@pages/pedidos/pedidos-hoy/pedidos-hoy.component';
import { PedidosEnProcesoComponent } from '@pages/pedidos/pedidos-en-proceso/pedidos-en-proceso.component';
import { PedidosDeliveryComponent } from '@pages/pedidos/pedidos-delivery/pedidos-delivery.component';
import { ClienteComponent } from '@pages/clientes/cliente/cliente.component';
import { ClientesDeudoresComponent } from '@pages/clientes/clientes-deudores/clientes-deudores.component';
import { ClientesTodosComponent } from '@pages/clientes/clientes-todos/clientes-todos.component';
import { ProductosComponent } from '@pages/productos/productos.component';
import { InformesComponent } from '@pages/informes/informes.component';
import { PedidoComponent } from '@pages/pedidos/pedido/pedido.component';
import { ProductosDeliveryComponent } from '@pages/productos-delivery/productos-delivery.component';
import { DetalleComponent } from '@modules/detalle/detalle.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { ArqueoComponent } from '@pages/arqueo/arqueo.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'pedido',
                component: PedidoComponent
            },
            {
                path: 'pedidos-todos',
                component: PedidosTodosComponent
            },
            {
                path: 'pedidos-hoy',
                component: PedidosHoyComponent
            },
            {
                path: 'pedidos-en-proceso',
                component: PedidosEnProcesoComponent
            },
            {
                path: 'pedidos-delivery',
                component: PedidosDeliveryComponent
            },
            {
                path: 'cliente',
                component: ClienteComponent
            },
            {
                path: 'clientes-deudores',
                component: ClientesDeudoresComponent
            },
            {
                path: 'clientes-todos',
                component: ClientesTodosComponent
            },
            {
                path: 'productos',
                component: ProductosComponent
            },
            {
                path: 'productos-delivery',
                component: ProductosDeliveryComponent
            },
            {
                path: 'informes',
                component: InformesComponent
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            {
                path: 'perfil',
                component: ProfileComponent
            },
            {
                path: 'arqueo',
                component: ArqueoComponent
            },
            {
                path: '',
                component: DashboardComponent
            }
        ]
    },
    {
        path: 'detalle/:parametro',
        component: DetalleComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
